// Installs process-wide error hooks that forward to the logger.
// NOTE: imports the logger facade; the cycle is safe because logger.error is only
// called at runtime (inside handlers), never at module-eval time.
import { logger } from './logger';

let installed = false;
let inConsoleError = false;

export function installGlobalErrorHandlers(): void {
  if (installed) return;
  installed = true;

  window.addEventListener('error', (event) => {
    logger.error('js-error', event.message || 'window error', {
      source: event.filename,
      line: event.lineno,
      col: event.colno,
      stack: (event.error as Error | undefined)?.stack,
    });
  });

  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason as { message?: string; stack?: string } | undefined;
    logger.error('js-error', 'unhandledrejection', {
      message: reason?.message ?? String(event.reason),
      stack: reason?.stack,
    });
  });

  // Mirror console.error into the log without recursing if logging itself errors.
  const original = console.error.bind(console);
  console.error = (...args: unknown[]) => {
    original(...args);
    if (inConsoleError) return;
    inConsoleError = true;
    try {
      logger.error('js-error', 'console.error', {
        args: args.map((a) =>
          a instanceof Error ? { message: a.message, stack: a.stack } : a
        ),
      });
    } catch {
      // swallow
    } finally {
      inConsoleError = false;
    }
  };
}
